import React, { forwardRef } from 'react';

import { CustomAutoComplete as AutoComplete } from 'components/commonStyles';

const CustomAutoComplete = forwardRef(({ size = 'large', ...props }, ref) => (
  <AutoComplete ref={ref} size={size} {...props} /> // eslint-disable-line
));

export default CustomAutoComplete;
